export default "__VITE_ASSET__DBM35HG5__"